export default "__VITE_ASSET__RxGT_BM9__"